import { render, staticRenderFns } from "./NippouComponent.vue?vue&type=template&id=4522c200&"
import script from "./NippouComponent.vue?vue&type=script&lang=js&"
export * from "./NippouComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports